import type { IMultiColumnsItemProps } from '../../MultiColumnsItem'

import { TextBlockDescriptionType1 } from 'blocks/TextBlock/Templates'
import { MultiColumnsRowGap } from '../../MultiColumns.h'
import { MultiColumnsItem } from '../../MultiColumnsItem'

export interface IMoviesDescriptions1Line extends Omit<
  IMultiColumnsItemProps,
  'children'
> {
  directors?: string
  stars?: string
}

export const MoviesDescriptions1Line = ({
  directors,
  stars,
  rowGap = MultiColumnsRowGap.INDENT_80,
  ...rest
}: IMoviesDescriptions1Line) => (
  <MultiColumnsItem rowGap={rowGap} {...rest}>
    {directors && (
      <TextBlockDescriptionType1
        title={'Directors:'}
        description={directors || ''}
      />
    )}
    {stars && (
      <TextBlockDescriptionType1 title={'Stars:'} description={stars || ''} />
    )}
  </MultiColumnsItem>
)
